import { type CssResponsiveVariables } from './types';

export interface ZIndexCssResponsiveVariables {
    '--zindex-background'?: number;
    '--zindex-content'?: number;
    '--zindex-footer'?: number;
    /** Bottom product bar ("Get a quotation"); must stay below footer for footer link hits. */
    '--zindex-sticky-bar'?: number;
    '--zindex-middleground'?: number;
    '--zindex-header'?: number;
    '--zindex-forground'?: number;
    '--zindex-popup'?: number;
    '--zindex-overlay'?: number;
    /** Header chrome when it must sit above full-screen overlays (e.g. cart). */
    '--zindex-header-above-overlay'?: number;
    /**
     * Fixed site header is z-index 99; bar inside uses 100. Page chrome (breadcrumbs, gallery expand)
     * uses this when it must be clickable above the bar.
     */
    '--zindex-page-above-header'?: number;
    /**
     * Below the fixed header stack so nav menu, mobile search, and store finder overlays capture input.
     */
    '--zindex-page-under-header-chrome'?: number;
    '--zindex-notifications'?: number;
}

export const zIndexCssResponsiveVariables: CssResponsiveVariables<ZIndexCssResponsiveVariables> = {
    'mobile.sm': {
        '--zindex-background': -1,
        '--zindex-content': 0,
        /* Below fixed header (99) so mobile nav stays visible; above sticky bar for footer clicks. */
        '--zindex-footer': 95,
        '--zindex-sticky-bar': 90,
        '--zindex-page-above-header': 100,
        '--zindex-page-under-header-chrome': 1,
        '--zindex-middleground': 500,
        '--zindex-header': 550,
        '--zindex-forground': 1000,
        '--zindex-popup': 1050,
        '--zindex-overlay': 1100,
        '--zindex-header-above-overlay': 1150,
        '--zindex-notifications': 1150,
    },
    'mobile.md': {},
    'mobile.lg': {},
    'tablet.sm': {},
    'tablet.lg': {},
    'desktop.sm': {},
    'desktop.md': {},
    'desktop.lg': {},
};
